export default {
  "monitor.tasks.status.canceled": "已取消",
  "component.globalHeader.search": "站内搜索",
  "component.globalHeader.search.example1": "搜索提示一",
  "component.globalHeader.search.example2": "搜索提示二",
  "component.globalHeader.search.example3": "搜索提示三",
  "component.globalHeader.help": "使用文档",
  "component.globalHeader.notification": "通知",
  "component.globalHeader.notification.empty": "你已查看所有通知",
  "component.globalHeader.message": "消息",
  "component.globalHeader.message.empty": "您已读完所有消息",
  "component.globalHeader.event": "待办",
  "component.globalHeader.event.empty": "你已完成所有待办",
  "component.noticeIcon.clear": "清空",
  "component.noticeIcon.cleared": "清空了",
  "component.noticeIcon.empty": "暂无数据",
  "component.noticeIcon.view-more": "查看更多",

  // ===== LLMMonitor =====
  "monitor.llm.popoverTitle": "LLM 在飞任务",
  "monitor.llm.leaseSuffix": "lease {seconds}s",
  "monitor.llm.limiterDisabled": "限流未启用",
  "monitor.llm.degraded": "Redis 连接异常,监控数据降级:{error}",
  "monitor.llm.unknown": "未知",
  "monitor.llm.emptyRunning": "当前没有 LLM 调用在跑",
  "monitor.llm.emptyDisabled": "LLM 限流未启用",
  "monitor.llm.queueTitle": "排队中 · {count}",
  "monitor.llm.queueHint": "等槽位释放",
  "monitor.llm.waitedPrefix": "等 {elapsed}",
  "monitor.llm.triggerTitle": "LLM 在飞 {count}/{max}",
  "monitor.llm.triggerTitleWithQueue":
    "LLM 在飞 {count}/{max} · 排队中 {waiting}",
  "monitor.llm.triggerTitleDisabled": "LLM 限流未启用 (max=0)",

  // LLM caller labels
  "monitor.llm.caller.parse-detect-marker": "项目-检测集标",
  "monitor.llm.caller.parse-infer-meta": "项目-推断元数据",
  "monitor.llm.caller.extract-characters": "抽取角色",
  "monitor.llm.caller.extract-scenes": "抽取场景",
  "monitor.llm.caller.gen-character-prompts": "角色衍生 Prompt",
  "monitor.llm.caller.storyboard-gen": "分镜生成",
  "monitor.llm.caller.storyboard-shot-regenerate": "单镜头重生",
  "monitor.llm.caller.video-prompt": "视频提示词",

  // ===== BusinessTaskMonitor (用户产品意图任务总览) =====
  "monitor.tasks.popoverTitle": "我的任务",
  "monitor.tasks.headerSummary": "{processing} 进行中 · {completed} 已完成",
  "monitor.tasks.empty": "暂无任务",
  "monitor.tasks.emptyHint": "抽角色 / 生分镜 / 出图等长跑动作会出现在这里",
  "monitor.tasks.degraded": "后端连接异常,监控数据降级:{error}",
  "monitor.tasks.viewAll": "查看我的请求",
  "monitor.tasks.sectionInFlight": "进行中",
  "monitor.tasks.sectionRecent": "最近完成",
  "monitor.tasks.recentHint": "近 24 小时",
  "monitor.tasks.elapsedSuffix": "已用 {elapsed}",
  "monitor.tasks.elapsedTotal": "耗时 {elapsed}",
  "monitor.tasks.triggerTitle":
    "我的任务 · 进行中 {processing} · 完成 {completed}",
  "monitor.tasks.triggerTitleEmpty": "我的任务",
  "monitor.tasks.openDetail": "查看子请求",
  "monitor.tasks.cancel": "取消",
  "monitor.tasks.cancelConfirm": "取消任务?",
  "monitor.tasks.cancelConfirmDesc": "停止后可重新发起。",
  "monitor.tasks.cancelConfirmOk": "确认取消",
  "monitor.tasks.cancelConfirmCancel": "继续任务",
  "monitor.tasks.cancelOk": "已取消 {affected} 条子任务",
  "monitor.tasks.cancelNoop": "该任务已不在进行中",
  "monitor.tasks.cancelFailed": "取消失败:{error}",

  // 任务状态
  "monitor.tasks.status.queued": "排队中",
  "monitor.tasks.waitTimedOut": "等待较久，仍在确认结果",
  "monitor.tasks.status.processing": "进行中",
  "monitor.tasks.status.completed": "已完成",
  "monitor.tasks.status.partial": "部分成功",
  "monitor.tasks.status.failed": "失败",

  // 业务任务的 kind 标签
  "monitor.tasks.kind.parse-project": "拆集拆场",
  "monitor.tasks.kind.adapt-novel": "小说改编",
  "monitor.tasks.kind.extract-characters": "抽取角色",
  "monitor.tasks.kind.extract-scenes": "抽取场景",
  "monitor.tasks.kind.gen-canonical": "角色主图",
  "monitor.tasks.kind.gen-character-prompts": "生成角色 Prompts",
  "monitor.tasks.kind.batch-generate": "角色批量出图",
  "monitor.tasks.kind.gen-sheet": "角色 Sheet",
  "monitor.tasks.kind.gen-scene-sheet": "场景四视图",
  "monitor.tasks.kind.gen-storyboard": "生成分镜",
  "monitor.tasks.kind.gen-shot-frames": "镜头首/中/尾帧",
  "monitor.tasks.kind.gen-video-prompts": "视频提示词",
  "monitor.tasks.kind.canvas-image": "画布生图",
  "monitor.tasks.kind.canvas-video": "画布生视频",
  "monitor.tasks.kind.canvas-audio": "画布配音",
  "monitor.tasks.kind.reverse-prompt-image": "反推提示词(图)",
  "monitor.tasks.kind.reverse-prompt-video": "反推提示词(视频)",
  "monitor.tasks.kind.gen-scene-canonical": "场景主锚",
  "monitor.tasks.kind.gen-scene-sheet-kind": "场景多视角 Sheet",
  "monitor.tasks.kind.gen-scene-extra-view": "场景补镜头",
  "monitor.tasks.kind.gen-shot-audio": "镜头配音",

  // 画布生图任务子类型(canvas-image 6 个 caller 区分;BusinessTask.sub_kind 驱动)
  "monitor.tasks.subkind.canvas_image_freegen": "画布生图",
  "monitor.tasks.subkind.canvas_image_matting": "抠图",
  "monitor.tasks.subkind.canvas_image_relight": "打光",
  "monitor.tasks.subkind.canvas_image_multi_view": "多视角",
  "monitor.tasks.subkind.canvas_image_inpaint": "选区重画",
  "monitor.tasks.subkind.canvas_image_outpaint": "扩图",
  "monitor.tasks.subkind.canvas_image_hd": "HD高清",

  // Modal「查看我的请求」
  "monitor.tasks.modal.title": "我的请求",
  "monitor.tasks.modal.refresh": "刷新",
  "monitor.tasks.modal.filterAll": "全部",
  "monitor.tasks.modal.colKind": "类型",
  "monitor.tasks.modal.colTarget": "目标",
  "monitor.tasks.modal.colStatus": "状态",
  "monitor.tasks.modal.colProgress": "进度",
  "monitor.tasks.modal.colCost": "花费",
  "monitor.tasks.modal.colTime": "时间",
  "monitor.tasks.modal.colRequests": "请求数",
  "monitor.tasks.modal.colActions": "操作",
  "monitor.tasks.modal.expand": "展开",
  "monitor.tasks.modal.collapse": "收起",
  "monitor.tasks.modal.requestColLabel": "子请求",
  "monitor.tasks.modal.requestColStatus": "状态",
  "monitor.tasks.modal.requestColCreated": "开始",
  "monitor.tasks.modal.requestColElapsed": "耗时",
  "monitor.tasks.modal.requestColCost": "花费",
  "monitor.tasks.modal.requestColError": "错误",
  "monitor.tasks.modal.noRequests": "该任务无子请求记录",
  "monitor.tasks.modal.detailFailed": "加载子请求失败:{error}",

  // ===== Footer =====
  "app.footer.copyright": "由 Genvas 提供支持",
};
